export interface ToggleConfig {
    label?: string;
    labelPosition?: 'left' | 'right';
    size?: 'sm' | 'md' | 'lg';
    isActive?: boolean;
    disabled?: boolean;
    id?: string;
    isLabel?: boolean;
}
export const DEFAULT_TOGGLE_CONFIG: ToggleConfig = {
    label: '',
    labelPosition: 'right',
    size: 'md',
    isActive: false,
    disabled: false,
    id: '',
    isLabel: true
};